import React, { useState } from "react";
import logo from "../resources/FF111.png";
import { BiPaperPlane } from "react-icons/bi";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <header className="w-full h-[80px] leading-[80px] flex items-center relative">
        <div className="container">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center gap-2">
              <a href="/">
                <img
                  src={logo}
                  className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px]"
                  alt="Fahim Ferdous Logo"
                />
              </a>

              <span className="text-xs font-bold uppercase bg-yellow-400 text-black px-2 py-1 rounded hidden sm:block">
                Beta
              </span>
            </div>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center gap-8">
              <ul className="flex items-center gap-6">
                <li>
                  <a
                    className="uppercase font-semibold text-xs text-gray-800 hover:bg-[#211033] hover:text-white hover:border border-[#211033] ease-in duration-200 max-h-[40px] px-3 py-3 rounded-md"
                    href="/underConstruction"
                  >
                    About
                  </a>
                </li>
                <li>
                  <a
                    className="uppercase font-semibold text-xs text-gray-800 hover:bg-[#211033] hover:text-white hover:border border-[#211033] ease-in duration-200 max-h-[40px] px-3 py-3 rounded-md"
                    href="/#services"
                  >
                    Services
                  </a>
                </li>
                <li>
                  <a
                    className="uppercase font-semibold text-xs text-gray-800 hover:bg-[#211033] hover:text-white hover:border border-[#211033] ease-in duration-200 max-h-[40px] px-3 py-3 rounded-md"
                    href="/portfolio"
                  >
                    Portfolio
                  </a>
                </li>
                <li>
                  <a
                    className="text-[#e83310] uppercase font-bold text-xs hover:bg-[#211033] hover:text-white hover:border border-blue-700 ease-in duration-200 max-h-[40px] px-3 py-3 rounded-md"
                    href="/learn"
                  >
                    Learn
                  </a>
                </li>
                <li>
                  <a
                    className="uppercase font-semibold text-xs text-gray-800 hover:bg-[#211033] hover:text-white hover:border border-[#211033] ease-in duration-200 max-h-[40px] px-3 py-3 rounded-md"
                    href="/contact"
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            {/* Desktop CTA Button */}
            <div className="hidden lg:flex items-center gap-4">
              <a
                href="https://wa.me/8801744353576"
                target="_blank"
                rel="noopener noreferrer"
                className="flex text-xs items-center gap-2 font-semibold bg-[#211033] text-white border border-teal-700 rounded-xl py-2 px-4 max-h-[40px] hover:bg-white hover:text-[#211033] ease-in duration-300"
                aria-label="Let's Talk on WhatsApp"
              >
                <BiPaperPlane />
                Let's Talk
              </a>
            </div>

            {/* Mobile Menu Button */}
            <div className="lg:hidden">
              <button
                onClick={toggleMenu}
                className="p-2 text-gray-700 rounded-md outline-none focus:border-gray-400 focus:border"
                aria-label="Toggle menu"
              >
                {isMenuOpen ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          <div
            className={`lg:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t border-gray-200 z-50 transition-all duration-300 ${
              isMenuOpen ? "opacity-100 visible" : "opacity-0 invisible"
            }`}
          >
            <div className="container py-4">
              <ul className="space-y-4">
                <li>
                  <a
                    className="block uppercase font-semibold text-sm text-gray-800 hover:bg-[#211033] hover:text-white px-4 py-3 rounded-md transition-colors duration-200"
                    href="/underConstruction"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    About
                  </a>
                </li>
                <li>
                  <a
                    className="block uppercase font-semibold text-sm text-gray-800 hover:bg-[#211033] hover:text-white px-4 py-3 rounded-md transition-colors duration-200"
                    href="/#services"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Services
                  </a>
                </li>
                <li>
                  <a
                    className="block uppercase font-semibold text-sm text-gray-800 hover:bg-[#211033] hover:text-white px-4 py-3 rounded-md transition-colors duration-200"
                    href="/portfolio"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Portfolio
                  </a>
                </li>
                <li>
                  <a
                    className="block text-[#e83310] uppercase font-bold text-sm hover:bg-[#211033] hover:text-white px-4 py-3 rounded-md transition-colors duration-200"
                    href="/learn"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Learn
                  </a>
                </li>
                <li>
                  <a
                    className="block uppercase font-semibold text-sm text-gray-800 hover:bg-[#211033] hover:text-white px-4 py-3 rounded-md transition-colors duration-200"
                    href="/contact"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Contact
                  </a>
                </li>
                <li className="pt-2">
                  <a
                    href="https://wa.me/88017443353576"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex text-sm items-center justify-center gap-2 font-semibold bg-[#211033] text-white border border-teal-700 rounded-xl py-3 px-4 hover:bg-white hover:text-[#211033] ease-in duration-300 mx-4"
                    aria-label="Let's Talk on WhatsApp"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <BiPaperPlane />
                    Let's Talk
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
      {/* 
<nav className="w-full shadow">
      <div className="justify-between px-4 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8">
        <div>
          <div className="flex items-center justify-between py-3 md:py-5 md:block">
            <a href="#">
              <img src={logo} className="w-20" />
            </a>
            <div className="md:hidden">
              <button
                className="p-2 text-gray-700 rounded-md outline-none focus:border-gray-400 focus:border"
                onClick={() => setNavbar(!navbar)}
              >
                {navbar ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>
        <div>
          <div
            className={`flex-1 justify-self-center pb-3 mt-8 md:block md:pb-0 md:mt-0 ${
              navbar ? "block" : "hidden"
            }`}
          >
            <ul className="items-center justify-center space-y-8 md:flex md:space-x-6 md:space-y-0">
              <li className="text-gray-600 hover:text-blue-600">
                <a href="javascript:void(0)">Home</a>
              </li>
              <li className="text-gray-600 hover:text-blue-600">
                <a href="javascript:void(0)">Blog</a>
              </li>
              <li className="text-gray-600 hover:text-blue-600">
                <a href="javascript:void(0)">About US</a>
              </li>
              <li className="text-gray-600 hover:text-blue-600">
                <a href="javascript:void(0)">Contact US</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav> */}
    </>
  );
};

export default Header;
